module.exports = __webpack_public_path__ + "img/1948-Alfa-Romeo-6C-2500.b3b55b2f.jpg";